import { MediaServerLazyImage } from '@/scopes/common/components/MediaServerLazyImage'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { sanitizeHTML } from '@sunwebgroup/uds-ui/utils'
import styles from './TipCard.module.css'

interface TipCardProps {
  title?: string
  description?: string
  mediaSrc?: string
  avatar?: string
  subtitle?: string
}

export function TipCard({ title, description, mediaSrc, avatar, subtitle }: TipCardProps) {
  return (
    <div className={styles.card}>
      {mediaSrc && (
        <div className={styles.imageWrapper}>
          <MediaServerLazyImage
            src={mediaSrc}
            alt={title}
            aspectRatio="16:9"
            widths={[320, 480, 600]}
          />
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.author}>
          {avatar && (
            <div className={styles.avatarWrapper}>
              <MediaServerLazyImage
                src={avatar}
                alt={title}
                aspectRatio="1:1"
                widths={[300]}
              />
            </div>
          )}
          <div className={styles.authorInfo}>
            {title && (
              <Typography variant="display-j-regular" as="h3">
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography variant="body-s-regular-tight" as="h4" className={styles.subtitle}>
                {subtitle}
              </Typography>
            )}
          </div>
        </div>
        {description && (
          // eslint-disable-next-line react-dom/no-dangerously-set-innerhtml
          <Typography variant="body-s-regular-tight" as="p" dangerouslySetInnerHTML={{ __html: sanitizeHTML(description) }} />
        )}
      </div>
    </div>
  )
}
